import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgPackagingGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 8v23.752H22.15l-1.721 1.973c.882 4.44-2.168 6.171-2.343 6.27l-.008.005-.275-.555-.285-.555c.108-.05 2.537-1.388 1.652-5.205l-.069-.307 4.08-4.66c.443-.445.68-.98.66-1.456a1.082 1.082 0 0 0-.364-.794l-.005-.003c-.23-.192-.9-.751-2.493.578l-.393.339-.698.603c-.164.14-.324.278-.474.409l-.411.355c-.846.713-1.544 1.15-2.42 1.15-1.356 0-2.202-.794-2.202-2.053v-7.811c-.265.277-.462.813-.737 1.675l-.11.324c-.072.218-.146.44-.225.658-.605 1.627-1.343 3.783-1.817 5.165l-.159.465a2.019 2.019 0 0 0-.059 1.08c.236 1.071.511 3.014.767 4.898.295 2.151.6 4.362.846 5.194l-1.18.357c-.27-.892-.558-2.991-.865-5.227l-.02-.146c-.256-1.854-.521-3.767-.748-4.798a3.325 3.325 0 0 1 .099-1.754 216.437 216.437 0 0 1 1.986-5.66c.089-.24.167-.479.242-.71.024-.075.048-.15.073-.223l.015-.047c.36-1.118.758-2.356 1.892-2.659V8H38Zm-2.242 22.513h1.013V9.239h-1.013v21.274ZM15.61 18.855v8.982c0 .376.109.812.974.812.046 0 .092-.009.137-.017.023-.005.046-.01.07-.012V9.24h-1.18v9.615Zm4.582 7.237c1.987-1.666 3.314-1.23 4.081-.565.482.416.767 1.02.797 1.685.03.833-.335 1.695-.993 2.36l-.826.941h11.278V9.239h-16.51v18.706c.035-.03.067-.054.099-.079s.064-.05.098-.08l.025-.02c.241-.205.536-.454.84-.723.166-.14.334-.285.5-.428.209-.18.415-.358.611-.523Zm3.186-6.84h6.53v1.239h-6.53v-1.24Z",
    fill: "currentColor"
  }));
}

export { SvgPackagingGlyph as default };
